import { render, staticRenderFns } from "./CreateEventModal.vue?vue&type=template&id=41737980&scoped=true&"
import script from "./CreateEventModal.vue?vue&type=script&lang=js&"
export * from "./CreateEventModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateEventModal.vue?vue&type=style&index=0&id=41737980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41737980",
  null
  
)

export default component.exports